module.exports = __webpack_public_path__ + "img/flag-PE.d4daa0f5.png";